import React from 'react';
import {Box, Typography} from '@mui/material';
import {useDashboard} from '../../context/DashboardContext';
import {isScopeSuppressed, scopeN, SUPPRESSION_MIN_N} from '../../utils/suppression';

/**
 * Shown once per dashboard page, under the header, when the dashboard's own
 * population is under the n floor (registry.scope_suppressed): every score on
 * the page is then a placeholder, and this says why. Participation and program
 * information stay visible, so the page is not empty.
 *
 * Passive: the page itself fetches; this only reads what the context holds.
 * Pages outside the DashboardContext mapping (Teacher PID) pass the data in
 * as `dashboardData`; when the prop is given it wins over the context.
 */
const ScopeSuppressedBanner = ({dashboardData: dataProp} = {}) => {
    const ctx = useDashboard({passive: true});
    const dashboardData = dataProp !== undefined ? dataProp : ctx.dashboardData;
    if (!isScopeSuppressed(dashboardData)) return null;
    const n = scopeN(dashboardData);
    return (
        <Box sx={{
            mb: 3, p: {xs: 2, md: 2.5}, backgroundColor: 'var(--brand-surface-subtle, #FEE2E2)', border: '1px solid #FECACA',
            borderLeft: '4px solid #DC2626', borderRadius: '0 8px 8px 0',
        }}>
            <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.7}}>
                <strong style={{color: '#DC2626'}}>Scores are hidden for this dashboard.&nbsp;</strong>
                Fewer than {SUPPRESSION_MIN_N} students completed the assessment{n !== null ? ` (n = ${n})` : ''}. To protect individual
                privacy, score values and bands are not shown. Participation and program information remain available.
            </Typography>
        </Box>
    );
};

export default ScopeSuppressedBanner;
